import Vue from 'vue'
import App from './App.vue'
import api from '@/api'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icons' // icon
import store from '@/store'
import './router/index'
import './assets/styles/index.scss'
import router from './router/routers'
import JsonViewer from 'vue-json-viewer'
import moment from 'moment';
Vue.prototype.$moment = moment;
// 事件捕获机制
// import 'default-passive-events'

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
import i18n, {
  changeLange
} from './utils/i18n'
import {
  hasBtnPermission
} from './utils/btnpermission'
import {
  getLang,
} from "@/utils/auth/";
// console.log = function () { }
let lang = ""
// 判断本地语言
if (getLang()) {
  lang = getLang()
} else {
  lang = navigator.language
}
changeLange(lang)
Vue.config.productionTip = false;
Vue.prototype.$has = hasBtnPermission
Vue.prototype.$http = api;
Vue.use(JsonViewer)
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
// import ElementUI from "element-ui"
// // 单独覆盖分页组件语言配置
// zhLocale.el.pagination = {
//   ...zhLocale.el.pagination,
//   pageSize: '每页数量',  // 修改下拉框显示的文本
// };
// Vue.use(ElementUI, { locale: zhLocale });  // 应用配置
new Vue({
  el: '#app',
  router,
  api,
  store,
  i18n,
  render: h => h(App),
})